import { Share, getSchemeUri } from '@apps-in-toss/web-framework';

export function tossSharePath(shareId: string, origin: string, schemeUri = ''): string {
  if (!/^[A-Za-z0-9_-]{12,120}$/.test(shareId)) throw new Error('공유 자료의 주소를 확인해주세요.');
  if (origin === 'https://carryonpan.apps.tossmini.com' || origin === 'https://carryonpan.web.tossmini.com') return `intoss://carryonpan/shared/${shareId}`;
  if (origin === 'https://carryonpan.private-apps.tossmini.com') {
    const scheme = new URL(schemeUri);
    const deploymentId = scheme.searchParams.get('_deploymentId');
    if (scheme.protocol !== 'intoss-private:' || scheme.hostname !== 'appsintoss' || !deploymentId || !/^[A-Za-z0-9_-]{8,120}$/.test(deploymentId)) throw new Error('현재 테스트 버전의 앱 주소를 확인하지 못했어요. 테스트 링크로 다시 들어와주세요.');
    return `intoss-private://appsintoss/shared/${shareId}?_deploymentId=${encodeURIComponent(deploymentId)}`;
  }
  throw new Error('토스 앱 안에서 공유 링크를 만들어주세요.');
}
export async function createTossTripLink(shareId: string, runtime = { createLink: Share.createLink, getSchemeUri }, origin = location.origin) {
  const path = tossSharePath(shareId, origin, origin === 'https://carryonpan.private-apps.tossmini.com' ? runtime.getSchemeUri() : '');
  // Only the non-secret object id goes to the link processing service.
  return runtime.createLink({ path });
}
export async function sendTossTripMessage(link: string, openingCode: string) {
  await Share.sendMessage({ message: `캐리온판에서 여행을 함께 확인해요.\n${link}\n\n열기 코드: ${openingCode}\n앱에서 이 코드를 붙여넣으면 여행을 볼 수 있어요. 코드를 받은 사람은 자료를 볼 수 있으니 필요한 사람에게만 전달해주세요.` });
}
